import { EventEmitter } from "events";
class MockController extends EventEmitter {
    homeId = 1;
    nodes = new Map();
}
class MockDriver extends EventEmitter {
    controller = new MockController();
    ready = true;
    allNodesReady = true;
    configVersion = "0.0.0-mock";
    statisticsEnabled = true;
    logConfig = {
        enabled: true,
        level: "debug",
        transports: [],
    };
    async start() {
        this.emit("driver ready");
    }
    getLogConfig() {
        return {
            ...this.logConfig,
            transports: [...(this.logConfig.transports ?? [])],
        };
    }
    updateLogConfig(config) {
        this.logConfig = {
            ...this.logConfig,
            ...config,
        };
    }
    updateUserAgent(_additionalUserAgentComponents) { }
    updateOptions(_options) { }
    async destroy() { }
}
export const createMockDriver = () => new MockDriver();
